// Two separate trainer constants for backwards compatibility
// (old existing already named jockey...)
const JockeyTrainerReductionTypes = Object.freeze({
  JOCKEY_CONDITIONS: 'JockeyConditions',
  TRAINER_CONDITIONS: 'TrainerConditions',
  HOMETRACK: 'HomeTrack',
  VICTORY_RICH: 'VictoryRich',
  OUT_OF_TOP_TEN: 'OutOfTopTen',
  JOCKEY_PERCENT: 'JockeysPercent',
  TRAINER_PERCENT: 'TrainersPercent',
});

export default JockeyTrainerReductionTypes;
